/**
 * Authentication Utilities
 * Helper functions for authentication and authorization
 */

/**
 * Check if user is authenticated
 */
export const isAuthenticated = () => {
  return !!localStorage.getItem('access_token');
};

/**
 * Get current user info from localStorage
 */
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

/**
 * Check if current user is admin
 */
export const isAdmin = () => {
  const user = getCurrentUser();
  return user?.user_type === 'admin';
};

/**
 * Get auth token
 */
export const getToken = () => {
  return localStorage.getItem('access_token');
};

/**
 * Set auth tokens and user info
 */
export const setAuthData = (accessToken, refreshToken, userType, userId) => {
  localStorage.setItem('access_token', accessToken);
  localStorage.setItem('refresh_token', refreshToken);
  localStorage.setItem('user', JSON.stringify({ user_type: userType, user_id: userId }));
};

/**
 * Clear auth data (logout)
 */
export const clearAuthData = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  localStorage.removeItem('selected_company');
};

/**
 * Get selected company
 */
export const getSelectedCompany = () => {
  return localStorage.getItem('selected_company');
};

/**
 * Set selected company
 */
export const setSelectedCompany = (companyId) => {
  localStorage.setItem('selected_company', companyId);
};
